import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import { FilterCard } from "~/components/Filters/FilterCard";
import { clearCamerasFilterValuesAction, removeFilterAction, setCameraMakeFilterValuesAction, setCameraModelsFilterValuesAction } from "~/store/filters/actions";
import { selectedCameraMakeFiltersSelector, selectedCameraModelsFiltersSelector } from "~/store/filters/selectors";
export const CamerasFilterCard = /*#__PURE__*/ memo((param)=>{
    let { CameraModelsSelect, CameraMakeSelect, ...props } = param;
    const dispatch = useDispatch();
    const selectedModels = useSelector(selectedCameraModelsFiltersSelector);
    const selectedMake = useSelector(selectedCameraMakeFiltersSelector);
    const clearCamera = useCallback(()=>{
        dispatch(clearCamerasFilterValuesAction());
    }, [
        dispatch
    ]);
    const onRemoveFilter = (filter)=>{
        dispatch(removeFilterAction({
            filter
        }));
        clearCamera();
    };
    const onSelectedModelsChange = useCallback((models)=>dispatch(setCameraModelsFilterValuesAction({
            models
        })), [
        dispatch
    ]);
    const onSelectedMakeChange = useCallback((makes)=>{
        batch(()=>{
            dispatch(setCameraMakeFilterValuesAction({
                make: makes[0]
            }));
            // if a user selects camera make, models have to be cleared, because they may not belong to the selected make
            if (makes.length > 0) {
                dispatch(setCameraModelsFilterValuesAction({
                    models: []
                }));
            }
        });
    }, [
        dispatch
    ]);
    const selectedMakeValues = useMemo(()=>selectedMake ? [
            selectedMake
        ] : [], [
        selectedMake
    ]);
    return /*#__PURE__*/ _jsx(FilterCard, {
        currentFilter: "camera",
        onClearClick: clearCamera,
        onRemoveFilter: onRemoveFilter,
        ...props,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-2",
            children: [
                /*#__PURE__*/ _jsx(CameraMakeSelect, {
                    selectedValues: selectedMakeValues,
                    onSelectionChange: onSelectedMakeChange
                }),
                /*#__PURE__*/ _jsx(CameraModelsSelect, {
                    make: selectedMake,
                    selectedValues: selectedModels,
                    onSelectionChange: onSelectedModelsChange
                })
            ]
        })
    });
});
CamerasFilterCard.displayName = "CamerasFilterCard";
